import * as React from 'react';
import { NotificationContext } from './notificationContext';

export default function NotificationProvider({ children }) {
  const [notification, _setNotification] = React.useState({
    show: false,
    type: '',
    title: '',
    message: '',
  })
  
  const setNotification = (newVal) => {
    _setNotification({...notification, ...newVal})
    setTimeout(function(){
      _setNotification({ ...newVal, show:false });
    },3000)
  }

  const value = [notification, setNotification];

  return (
    <NotificationContext.Provider value={value}>
      { children }
    </NotificationContext.Provider>
  )
}